import { ReactNode } from 'react';
import LandingNav from '@/components/landing/LandingNav';
import Footer from '@/components/landing/Footer';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <LandingNav />
      <main className="page-shell-main">{children}</main>
      <Footer />
    </div>
  );
}
